import { createAsyncThunk } from '@reduxjs/toolkit'
import { AxiosError } from 'axios'

import clientSDK from '../../../App/ClientSDK'
import {
  axiosErrorHandler,
  IThunkReject,
  ITransformerError,
} from '../../../App/Util/axiosErrorHandler'
import { TErrorDescriptor } from '../../../ErrorHandling/store'
import { IUpdateBlock } from '../../types'
import { IAPIUpdateBlock } from '../../types/api'
import { updateBlockTransformer } from '../transformer/updateBlockTransformer'

interface IUpdateBlockReturn {
  status: 'success'
}

export const updateBlock = createAsyncThunk<
  IUpdateBlockReturn,
  IUpdateBlock,
  IThunkReject<any>
>('update/block', async (payload, { rejectWithValue }) => {
  const { blockUuid } = payload
  let apiBlockUpdateObject: IAPIUpdateBlock

  try {
    apiBlockUpdateObject = updateBlockTransformer(payload.data)
  } catch {
    const transformerError: ITransformerError = {
      error: { message: 'Unable to transform block to API version' },
      type: 'transformer-error',
    }
    return rejectWithValue(transformerError)
  }

  let apiData: null | IUpdateBlockReturn = null

  try {
    const promise = clientSDK
      .instance()
      .put<{ status: 'success' }>(
        `calendar/blockeds/${blockUuid}`,
        apiBlockUpdateObject,
      )

    const result = await promise
    apiData = result.data
  } catch (error) {
    const handleAxiosError = axiosErrorHandler<TErrorDescriptor>(res => res)
    const generatedError = handleAxiosError(error as Error | AxiosError)
    return rejectWithValue(generatedError)
  }

  return apiData
})
